import { Controller  } from "@hotwired/stimulus";
import DataTable from "datatables.net";
import {stimulus} from "../init"
export default class Autosubmit  extends Controller {
    connect() {
        // this.table = new DataTable(this.element, {
        //     responsive: true,
        //     paging: true,
        //     searching: true,
        //     ordering: true,
        //     info: true,
        //     autoWidth: false,
        // });
    }

    disconnect() {
        this.table.destroy();
    }
}
stimulus.register('autosubmit', Autosubmit)
